import { SearchParam } from '../shared/model/searched-data.model';
// import { CountryISO } from 'ngx-intl-tel-input';

export const Constants = Object.freeze({
	HTTP_RESPONSE_OK: 200,
	NO_CONTENT: 204,
	HTTP_UNAUTHORISED: 401,
	HTTP_BAD_REQUEST: 400,
	HTTP_NOT_FOUND: 404,
	HTTP_TOO_MANY_REQUEST: 429,
	AUTH_401101: "AUTH-401101",
	AUTH_401102: "AUTH-401102",
	SESSION_TIMEOUT_MESSAGE: "Invalid session for the user, session is expired.",

	ROLE_FLEET_OPERATOR: "ROLE_FLEET_OPERATOR",
	ROLE_RENTER: "ROLE_RENTER",
	ROLE_INSTANCE_ADMIN: "ROLE_INSTANCE_ADMIN",
	ROLE_ACCOUNT_ADMIN: "ROLE_ACCOUNT_ADMIN",
	ROLE_INSTANCE_QA_USER: "ROLE_INSTANCE_QA_USER",
	ROLE_ACCOUNT_DEVELOPER: "ROLE_ACCOUNT_DEVELOPER",
	ROLE_DONGLE_PROVIDER_ADMIN: "ROLE_DONGLE_PROVIDER_ADMIN",
	ROLE_ACCOUNT_FINANCE_USER: "ROLE_ACCOUNT_FINANCE_USER",

	// Account Type
	FLEET_CONSUMER_SERVICE: "FLEET_CONSUMER_SERVICE",
	FLEET_COMMERCIAL_SERVICE: "FLEET_COMMERCIAL_SERVICE",
	VEHICLE_SERVICE_PROVIDER: "VEHICLE_SERVICE_PROVIDER",
	INTERNAL_AFFILIATES: "INTERNAL_AFFILIATES",

	// Account category
	RENTAL_FLEET: "RENTAL_FLEET",
	MOBILITY_COMPANY: "MOBILITY_COMPANY",
	FLEET_MANAGEMENT_COMPANY: "FLEET_MANAGEMENT_COMPANY",
	FIELD_SERVICE_COMPANY: "FIELD_SERVICE_COMPANY",
	DEALER: "DEALER",
	CORPORATE: "CORPORATE",
	FINANCING_GROUP: "FINANCING_GROUP",
	// Account category for Service Provider
	MOBILITY_SERVICE: "MOBILITY_SERVICE",
	USAGE_BASED_INSURANCE: "USAGE_BASED_INSURANCE",
	UTILITY_COMPANY: "UTILITY_COMPANY",
	RESELLER: "RESELLER",
	CORPORATE_CUSTOMER: "CORPORATE_CUSTOMER",

	// Challenge Name
	SMS_MFA: "SMS_MFA",
	NEW_PASSWORD_REQUIRED: "NEW_PASSWORD_REQUIRED",
	RESET_PASSWORD_REQUIRED: "RESET_PASSWORD_REQUIRED",
	CUSTOM_CHALLENGE: "CUSTOM_CHALLENGE",

	// IP Address URL
	IPADDRESS_CHECK_URL: "http://ip-api.com/json", //TODO confirm before removing

	MFA_URL: 'idm/api/mfa/custom',
	ONBOARDING_URL: "onboarding/",
	PROVISIONING_URL: "provisioning/",
	LOGIN_URL: 'idm/api/access_token/custom', //"auth/signin",
	NEW_PASSWORD_URL: 'idm/api/new_password',
	FORGOT_PASSWORD_URL: 'idm/api/forgot_password',
	CONFIRM_PASSWORD_URL: 'idm/api/confirm_password',
	NOTIFICATION_URL: "notification",
	GET_USER_DETAILS: "api/me",
	SEPARATOR: "/",
	IDM: "idm",
	API: "api",
	CHANGE_PASSWORD: "change_password",
	SEARCHSERVICE: "searchservice/",
	SEARCH: "/search",
	BILLING: "billing/",
	CHARGING: "charging/",
	SWAGGER_RESOURCES: "/swagger-resources",
	SUBGROUPS: "/subgroups",
	PAGINATED: "/paginated",
	FILTERS: "/filters",
	OEM: "/oem",
	USERS: "/users",
	NOTIFICATIONS: "/notifications",
	ACTIONS: "/actions",
	// VERSION: "v1/",
	DEFLEET: "/defleet",
	ENROLL: "/enroll",
	UNENROLL: "/unenroll",
	UNENROLLMENT: "/unenrollment",
	ENROLLMENT: "/enrollment",
	DATA: "/data",
	VERIFY: "/verify",
	PHONE: "/phone",
	ACCOUNTS_URL: "/accounts",
	CODE: "/code",
	MFA: "/mfa",
	RESEND: "/resend",
	ASSETS: "assets/",
	DOCS: "docs/",
	DEVICE: "/device",

	TOAST_DURATION_SHORT: 1000,
	TOAST_DURATION_LONG: 2000,
	AUTO_PAYMENT_DAY_OFFSET: 2,
	AUTO_PAYMENT_DATE_OFFSET: 2 * 24 * 60 * 60 * 1000,
	PAYMENT_CONFIRMATION_MESSAGE_ACH_1: "The Account ending with ",
	PAYMENT_CONFIRMATION_MESSAGE_CARD_1: "The Card ending with ",
	PAYMENT_CONFIRMATION_MESSAGE_2: " has been setup for auto payment and would be automatically charged ",
	PAYMENT_CONFIRMATION_MESSAGE_3: " days before Invoice due date.",

	REMOTE_HORN: "REMOTE_HORN",
	REMOTE_LIGHT: "REMOTE_LIGHT",
	REMOTE_HORN_LIGHT: "REMOTE_HORN_LIGHT",
	REMOTE_DOOR_LOCK: "REMOTE_DOOR_LOCK",
	REMOTE_DOOR_UNLOCK: "REMOTE_DOOR_UNLOCK",
	REMOTE_ENGINE_START: "REMOTE_ENGINE_START",
	REMOTE_ENGINE_STOP: "REMOTE_ENGINE_STOP",
	REMOTE_LOCATION: "TELEMATICS_LOCATION",

	LIGHT_BTN: "LIGHT_BTN",
	HORN_BTN: "HORN_BTN",
	ENGINE_BTN: "ENGINE_BTN",
	DOOR_BTN: "DOOR_BTN",
	LOCATION_BTN: "LOCATION_BTN",

	ALERT_TYPE_SPEED: "SPEED",
	ALERT_TYPE_CURFEW: "CURFEW",
	ALERT_TYPE_GEOFENCE: "GEOFENCE",

	/**
	 * Search Variables
	 */
	ACCOUNTS: "ACCOUNTS",
	VEHICLES: "VEHICLES",
	VEHICLE_SUMMARY: "VEHICLE_SUMMARY",
	LOCATIONS: "LOCATIONS",
	SERVICE_PACKAGE: "SERVICE_PACKAGE",
	SERVICE: "SERVICE",
	SERVICE_USAGE: "SERVICE_USAGE",
	USERS_ENTITY: "USERS",

	SEARCH_PARAM: new Map<string, SearchParam>([
		["/rental-fleet", { "scope": null, "filters": ["accountId"], "placeholder": "Search VIN, Package" }], //, Location
		["/service-provider/dashboard", { "scope": null, "filters": ["accountId"], "placeholder": "Search VIN, Package" }],
		["/account-management", { "scope": null, "filters": ["accountId"], "placeholder": "Search VIN, Package" }], //, Location
		["/service-provider/account-management", { "scope": null, "filters": ["accountId"], "placeholder": "Search VIN, Package" }],
		["/locations", { "scope": "ACCOUNTS_DATA", "filters": ["accountId"], "placeholder": "Search Location" }],
		["/vehicles", { "scope": "VEHICLES", "filters": ["accountId"], "placeholder": "Search VIN" }],
		["/usage", { "scope": "SERVICE_USAGE", "filters": ["accountId"], "placeholder": "Search VIN, Service" }],
		["/commercial-fleet", { "scope": null, "filters": ["accountId"], "placeholder": "Search VIN, Package" }],
		["/dealer", { "scope": null, "filters": ["accountId"], "placeholder": "Search VIN, Package" }],
		["/admin-roles", { "scope": "USERS", "filters": ["accountId"], "placeholder": "Search User" }]
	]),

	INACTIVE: "INACTIVE",
	PENDING: "PENDING",
	ENABLED: "ENABLED",

	UNKNOWN_ERROR: "An error occurred on the server. Please retry later or contact support if the issue persists",

	PASSWORD_RULE: "The password must be at least 8 characters long and must contain at least a \
	number, a special character, an uppercase and a lowercase letter. \
	Special characters allowed are !, @, #, $, %, ^, &, *",
	PASSWORD_FORMAT_ERROR: "Password should contain at least a number, a special \
	character, an uppercase and a lowercase letter, and must be at least 8 characters long.\
	Special characters allowed are !, @, #, $, %, ^, &, *",
	PASSWORD_RESET_LINK_PARAM_MISSING_ERROR: "Malformed link, please try generating the code again.",

	PAYMENT_CARDS: new Map<string, string>([
		['credit-card', 'fa fa-credit-card-alt'],
		['amex', 'fa fa-cc-amex'],
		['diners-club', 'fa fa-cc-diners-club'],
		['discover', 'fa fa-cc-discover'],
		['jcb', 'fa fa-cc-jcb'],
		['mc', 'fa fa-cc-mastercard'],
		['paypal', 'fa fa-cc-paypal'],
		['stripe', 'fa fa-cc-stripe'],
		['visa', 'fa fa-cc-visa'],
		['google-wallet', 'fa fa-google-wallet']
	]),

	PAYMENT_CARDS_LOGO: new Map<string, string>([
		['MC', 'assets/images/payment_icons/mc.png'],
		['DISC', 'assets/images/payment_icons/discover.png'],
		['VISA', 'assets/images/payment_icons/visa.png'],
		['AE', 'assets/images/payment_icons/american_express.png']
	]),

	LOCALE_ISD_MAP: new Map([
		["en-US", '+1']
	]),

	STATUS_NAME_MAP: new Map<string, string>([
		['NONE', 'None'],
		['ATTACHED', 'Attached Date'],
		['ENABLED', 'Enabled Date'],
		['LINKED', 'Linked Date'],
		['UNLINKED', 'Unlinked Date']
	]),

	// Portal Mode
	DEVELOPER_MODE: "DEVELOPER",
	ADMIN_MODE: "ADMIN",

	// File properties
	IMAGE_UPLOAD_MAX_SIZE_KB: 300,
	ALLOWED_IMAGE_TYPE: ["jpg", "jpeg", "png"],
	SUPPORT_FILE_MAX_SIZE_MB: 10,

	// Error messages
	IMAGE_UPLOAD_FILE_SIZE_ERROR_MESSAGE: "Image file size should be less than 300KB.",
	IMAGE_UPLOAD_FILE_TYPE_ERROR_MESSAGE: "Image file should be jpg or jpeg or png.",
	SUPPORT_FILE_SIZE_ERROR_MESSAGE: "File size should be less than 10MB.",
	SUPPORT_FILE_SIZE_ZERO_ERROR_MESSAGE: "File size should be greater than 0.",
	SEARCH_RESULT_NOT_FOUND: "No results found for the search.",
	SEARCH_NOT_AVAILABLE_MESSAGE: "Search is available for B2B Account, Service, Package, VIN and Usage attributes only",
	VALIDATE_EMAIL_REGEX: '[a-z0-9]+@[a-z]+\.[a-z]{2,3}',
	MFA_FORM_LABEL: "Enter verification code",
	MFA_FORM_MESSAGE: "Verification code has been sent through",
	MFA_FORM_MESSAGE_TIME_LIMIT: "The code will expire in 3 minutes.",
	MFA_CODE_RESEND_LIMIT_EXCEED: "# of requests limit for resend verification code exceeded, please try to login again.",
	INVALID_VERIFICATION_CODE: "Invalid verification code.",
	MFA_WRONG_CODE_LIMIT_EXCEED: "Invalid code, # of attempts limit exceeded, please try to login again.",
	MFA_VERIFY_CODE_SESSION_TIMEOUT: "Verification code expired. Please try to login again.",
	MFA_RESEND_CODE_SESSION_TIMEOUT: "Session timeout to resend code. Please try to login again.",
	LOGIN_SESSION_EXPIRED: "Your current login session has expired. Please try to login again using the temporary password.",
	MFA_SMS_CHARGES_MESSAGE: "NissanConnect Commercial will use this number to enable an extra level of security to your user account in the form of multi-factor authentication (MFA). We will send one text message per login with a unique one-time passcode (OTP). Message and data rates may apply.",
	MFA_TNC_LINK: "https://conexio.life/tnc.html",
	MFA_UPDATE_BUTTON_CLICK_MESSAGE: "When the UPDATE is clicked, OTP will be sent to you as a text message for phone number verification.",
	MFA_VERIFY_CODE_FORM_MESSAGE_PRE_MOBILE_NUMBER: "Verification code has been sent as text to you at",
	MFA_VERIFY_CODE_FORM_MESSAGE_POST_MOBILE_NUMBER: "(#). Please enter the code below to verify your phone number.",
	RETRY_LATER: "Please retry after sometime.",
	NO_DEVICE_VEHICLE_MESSAGE: "No Vehicle attached with the device.",
    NO_VEHICLE_DEVICE_MESSAGE: "Device information not available for the vehicle.",
	DEVICE_VEHICLE_UNLINK_MESSAGE: "Confirm Unlink Device from the Vehicle <VIN#> ?",
	// DEVICE_VEHICLE_LINK_MESSAGE: "Please enter the VIN to which you want to attach the vehicle.",
	// DEVICE_VEHICLE_LINK_MESSAGE: "Type in VIN to search the vehicle to which the device <Device #> will be linked.",
	DEVICE_VEHICLE_LINK_MESSAGE: "Type in VIN to search the vehicle to which the device will be linked.",
	INVALID_VIN_MESSAGE: "Vehicle not found for the VIN <VIN#>. Please check and type in again.",
	// Conversion Constants
	KM_TO_MILE: 0.621371,
	LITER_TO_GALLON: 0.264172,
	MMCUBE_TO_LITER: 0.000001,
	KMPH_TO_MPH: 0.621371,
	BAR_TO_PSI: 14.5038,
	KMPL_TO_MPG: 2.3521458,
	// Conversion Constants End
	IGN_OFF: "Trg_IGN_OFF",
	MINIMUM_DEVICE_ERROR: "All devices cannot be deleted. The vehicle is required to have at least 1 device.",

	PRODUCT_TYPE_MAP: new Map([
		["LICENSE_BASED", "License Fee"],
		["DEFAULT_DATA_TRNS", "API Product"],
		["DEFAULT_DATA_NOTIFY_TRNS", "API Transaction"],
		["DATA", "Data Payload"],
		["FLAT_RATE", "Flat Fee"],
		["DEFAULT_SERVICE_RATES", "Default Service Rates"],
		["DEFAULT_SERVICE_RATES_OVERAGE_PRICING", "Default Service rates Overage Pricing"],
		["DEFAULT_DATA_UNIT", "Data Payload"]
	]),
	USAGE_TIER_MAP: new Map([
		["VEHICLE", "Per Vehicle"]
	]),

	BILLING_PRORATIONS: new Map<string, string>([
		["FULL_CYCLE", "Full Cycle"],
		["PRO_RATED", "Pro-rated"],
		["PRO_RATED_ADD_ONLY", "Pro-rate on Add"]
	]),

	// default locale, region, coutnries used in service package detail to show values for package which does not have these fields set
	DEFAULT_REGION: "North America",
	DEFAULT_LOCALES: [
		{
			"locale": "en_ES",
			"language": "English",
			"country": "US",
			"isd": "+1"
		}
	],
	DEFAULT_COUNTRIES: ["USA"],
	// PREFERRED_COUNTRIES: [CountryISO.UnitedStates],
	PREFERRED_COUNTRIES: ['us'],//['in', 'us', 'gb']

	/* COUNTRIES: [
		{ "label": "India +91", "dialCode": "+91", "name": "India" },
		{ "label": "United States +1", "dialCode": "+1", "name": "US" },
		{ "label": "United Kingdom +44", "dialCode": "+44", "name": "United Kingdom" },
		{ "label": "Australia +61", "dialCode": "+61", "name": "Australia" },
		{ "label": "Canada +1", "dialCode": "+1", "name": "Canada" }
	], */

	IMPORT_VEHICLE_SAMPLE_CSV_URL: "F1DC00184B024B078AED767AB6327965/import/NCC_FleetVehicleEntry_YYYYMMDD.csv",
	IMPORT_LOCATION_SAMPLE_CSV_URL: "F1DC00184B024B078AED767AB6327965/import/NCC_AddLocation_YYYYMMDD.csv",
	IMPORT_LOCATION_VEHICLE_SAMPLE_CSV_URL: "F1DC00184B024B078AED767AB6327965/import/NCC_VehicleLocationMapping_YYYYMMDD.csv",
	IMPORT_VEHICLE_PACKAGE_MAPPING_SAMPLE_CSV_URL: "F1DC00184B024B078AED767AB6327965/import/NCC_VehicleServicePackageMapping_YYYYMMDD.csv",
	DEFAULT_ISD: "+1",
	DEFAULT_REGION_TYPE: "COUNTRY",
	IS_HIDE_USAGE_DETAILS: false,
	EVENT_PAGE_SIZE: 10,
	TRIP_PAGE_SIZE: 10,
	KINESIS_DATA_ENABLED_FOR_ACCOUNT_PROD: ["62ec0ce9fe855b69d34d8c22"],
	KINESIS_DATA_ENABLED_FOR_ACCOUNT_STAGE: ["6549505c07d14f30ed229f52"],
	PACKAGE_PRODUCT_CATEGORY_SERVICE: "SERVICE",
	PACKAGE_PRODUCT_CATEGORY_DATA: "DATA",
	PACKAGE_PRODUCT_CATEGORY_APP: "APP",
	PACKAGE_PRODUCT_CATEGORY_FLEET_APP: "FLEET_APP",
	PACKAGE_PRODUCT_CATEGORY_MOBILITY_APP: "MOBILITY_APP",
	STAGING: "STAGING",
	PRODUCTION: "PRODUCTION",

	// Enrollment status
	ENROLLMENT_IN_PROGRESS: "ENROLLMENT_IN_PROGRESS",
	ENROLLMENT_INITIATED: "ENROLLMENT_INITIATED",
	ENROLLMENT_RETRY: "ENROLLMENT_RETRY",
	UNENROLLMENT_IN_PROGRESS: "UNENROLLMENT_IN_PROGRESS",
	UNENROLLMENT_RETRY: "UNENROLLMENT_RETRY",
	ENROLLMENT_FAILED: "ENROLLMENT_FAILED",
	ENROLLED: "ENROLLED",
	NOT_ENROLLED: "NOT_ENROLLED",
	NOT_APPLICABLE: "NOT_APPLICABLE",
	ENROLLMENT_CANCELED: "ENROLLMENT_CANCELED",
	UNENROLLMENT_INITIATED: "UNENROLLMENT_INITIATED",
	UNENROLLED: "UNENROLLED",
	UNENROLLMENT_FAILED: "UNENROLLMENT_FAILED",
	UNENROLLMENT_CANCELED: "UNENROLLMENT_CANCELED",
	SUPPORT_LINK: "nna-support@conexio.ai",
	DELETED: "DELETED",
	
	// NNA_NCC_CONSTANTS
	// STG
	// API_KEY: "14CC9C7130724F13B6E7C18DB35FA762",
	// NMAC_ACCOUNT_ID: "652408d707d14f03e3f528fc",
	// HERTZ_ACCOUNT_ID: ["5c99234e07d14f083ac8e71f"]

	// PROD
	API_KEY: "14CC9C7130724F13B6E7C18DB35FA762",
	NMAC_ACCOUNT_ID: "65241174fe855b04317f739e",
	HERTZ_ACCOUNT_ID: ["6167cbbefe855b7957e5b4ea"]
});